import React, { useState, useEffect, useContext } from 'react'
import { useParams } from 'react-router-dom'
import Container from '@mui/material/Container'
import { authContext } from '../../../contexts/AuthContext'
import { clientContext } from '../../../contexts/ClientContext'
import Button from '@mui/material/Button'
import Grid from '@mui/material/Grid'
import Box from '@mui/material/Box'
import Tabs from '@mui/material/Tabs'
import Tab from '@mui/material/Tab'
import 'react-block-ui/style.css'
import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router-dom'
import {
  listWorkspacesByClientId,
  listWorkspaceSubcategories
} from '../../../services/workspaces'
import ClientSocietiesSection from './SocietyCompliance/ClientSocietiesSection'
import AssignDocumentsDialog from './UploadDialogs/AssignDocumentsDialog'
import ConfigurationDialog from './UploadDialogs/ConfigurationDialog'
import UploadStatusDialog from './UploadDialogs/UploadStatusDialog'
import ClientDirectory from './ClientDirectory'

export const ClienteDetalleIndex = (props) => {
  // Pagina de navegacion de documentos del cliente, para usuarios internos BLP-PRB
  const { t } = useTranslation()
  const { data, setId } = useContext(clientContext)
  const { auth } = useContext(authContext)
  const history = useHistory()

  const { client_id } = useParams()

  const [subcategories, setSubcategories] = useState([])
  const [activeTab, setActiveTab] = useState('directory')

  const [uploadStep, setUploadStep] = useState(0)
  const [selectedClientOrCompanyId, setSelectedClientOrCompanyId] =
    useState(null)
  const [selectedWorkspaceId, setSelectedWorkspaceId] = useState(null)
  const [selectedSubcategoryId, setSelectedSubcategoryId] = useState(null)
  const [selectedFileId, setSelectedFileId] = useState(null)
  const [selectedFiles, setSelectedFiles] = useState([])
  const [finalConfig, setFinalConfig] = useState([])

  useEffect(() => {
    setId(client_id)

    fetchClientCategories()
  }, [])

  const fetchClientCategories = async () => {
    /* Get subcategories by workspace */
    let workspaces = await listWorkspacesByClientId(client_id)
    let subcategories = []
    workspaces.map(async (workspace) => {
      let list = await listWorkspaceSubcategories(workspace.workspace_id)
      subcategories.push({
        workspace: workspace,
        subcategories: list
      })
    })

    setSubcategories(subcategories)
  }

  if (!data) {
    return <div />
  }

  return (
    <Container maxWidth='lg' sx={{ mt: 4, mb: 4 }}>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          borderBottom: 1,
          borderColor: 'divider',
          mb: 2
        }}
      >
        <Tabs
          value={activeTab}
          onChange={(e, newValue) => setActiveTab(newValue)}
        >
          <Tab label={t('Directory')} value='directory' />
          {window.$brand === 'PRB' && auth.user.userType === 'blp_admin' && (
            <Tab label={t('legal_entities_tab')} value='societies' />
          )}
        </Tabs>

        {(auth.user.userType === 'blp_admin' ||
          window.$brand === 'PRB' ||
          window.$brand === 'BLP' ||
          (window.$brand === 'STRATOS' &&
            (auth.user.userType === 'blp_admin' ||
              auth.user.userType === 'external_admin')) ||
          auth.user.userType === 'admin_subway' ||
          auth.user.userType === 'admin_kraft') && (
          <Button
            sx={{
              mr: 3,
              mb: 1,
              backgroundColor: window.$brand === 'PRB' ? '#17afb6' : '#102a46',
              borderRadius: window.$brand === 'PRB' ? 0 : 5
            }}
            variant='contained'
            onClick={() => {
              history.push('/Administracion', { client: data })
            }}
          >
            {t('go_to_settings')}
          </Button>
        )}
      </Box>

      <Box sx={{ display: activeTab === 'directory' ? 'block' : 'none' }}>
        <Grid
          container
          spacing={{ xs: 2, md: 3 }}
          columns={{ xs: 6, sm: 6, md: 12 }}
        >
          <Grid item xs={12}>
            <ClientDirectory
              userId={auth.user.id}
              subcategories={subcategories}
            />
          </Grid>
        </Grid>
      </Box>

      <Box sx={{ display: activeTab === 'societies' ? 'block' : 'none' }}>
        <ClientSocietiesSection clientId={client_id} />
      </Box>

      <AssignDocumentsDialog
        open={uploadStep === 1}
        handleClose={() => {
          setUploadStep(0)
        }}
        onContinue={(
          files,
          selectedClientOrCompany,
          selectedWorkspace,
          selectedSubcategory,
          selectedFile
        ) => {
          setUploadStep(2)
          setSelectedFiles(files)
          setSelectedClientOrCompanyId(selectedClientOrCompany)
          setSelectedWorkspaceId(selectedWorkspace)
          setSelectedSubcategoryId(selectedSubcategory)
          setSelectedFileId(selectedFile)
        }}
        subcategories={subcategories}
        clientId={client_id}
      />
      <ConfigurationDialog
        open={uploadStep === 2}
        files={selectedFiles}
        handleBack={() => {
          setUploadStep(1)
        }}
        handleUpload={(config) => {
          setUploadStep(3)
          setFinalConfig(config)
        }}
        selectedSubcategoryId={selectedSubcategoryId}
      />
      <UploadStatusDialog
        open={uploadStep === 3}
        config={finalConfig}
        handleClose={() => {
          setUploadStep(0)
        }}
        clientId={client_id}
        categoryId={selectedWorkspaceId}
        subcategoryId={selectedSubcategoryId}
        assignedBy={auth.user.id}
        assignedTo={selectedClientOrCompanyId}
        fileId={selectedFileId}
      />
    </Container>
  )
}
